import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[ftState]',
})
export class StateDirective {
	constructor(public viewContainerRef: ViewContainerRef) {}
}
